import {createReducer} from '@reduxjs/toolkit';
import {cleanAttributesInfo} from 'src/modules/attributes/services/actions';
import {getAllAttributeRelationInfoSuccess} from 'src/openapi/apis/AttributeControllerApi';
import {AttributeRelationInfo} from 'src/openapi/models/AttributeRelationInfo';

type State = {
    data: Array<AttributeRelationInfo>,
};

const defaultState = {
    data: [],
};

export const attributesInfo = createReducer<State>(defaultState, builder => builder
    .addCase(getAllAttributeRelationInfoSuccess, (state, action) => {
        state.data = action.payload.data;
    })
    .addCase(cleanAttributesInfo, state => {
        state.data = [];
    }),
);
